export default __webpack_public_path__ + "static/media/97_QT_Header_1.fe454e3e.png";